import { Icon, Text } from '@chakra-ui/react';
import { useContext } from 'react';
import { GoLinkExternal } from 'react-icons/go';
import { Link } from 'react-router-dom';
import { Home_context } from '../../context/home_context';

export default function Raw_materials_listing_component({
  name,
  supplier,
  inci_name,
  description,
  link,
  el,
}) {
  const { HendleSelect } = useContext(Home_context);
  return (
    <>
      <div className="raw_material_component_box  p-[8px]  ">

          <div
            onClick={() => HendleSelect(el)}
            className="hover:cursor-pointer"
          >
            <div className="flex items-center gap-2">
              <Text className="font-bold text-[15px] ">{name}</Text>
              {/* <div className="flex items-center p-1 bg-[#f0f0f0] rounded-md">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient
                      id="grayLinearGradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="0%"
                    >
                      <stop offset="0%" stop-color="lightgray" />
                      <stop offset="100%" stop-color="darkgray" />
                    </linearGradient>
                  </defs>
                  <circle
                    cx="10"
                    cy="10"
                    r="5"
                    fill="url(#grayLinearGradient)"
                    stroke="black"
                    stroke-width="0.5"
                  />
                </svg>
                <Text className="text-[14px]">{supplier}</Text>
              </div> */}
            </div>
          </div>
    
        <div>
          <Text className=" text-[15px] text-gray-500 font-semibold">
            {inci_name}
          </Text>
        </div>
        <div>
          <Text className="text-[15px]   line-clamp-2 ">{description}</Text>
        </div>
        {/* <div>
          <a
            href={link}
            target="blank"
            className="link_color text-[15px] hover:cursor-pointer "
          >
            <Icon as={GoLinkExternal} /> show more
          </a>
        </div> */}
      </div>
      <div className="py-[16px]">
        <hr />
      </div>
    </>
  );
}
